define('app/views/shipping_address_view',[
 'app/setup', 'app/models/shipping_address'
], function(takhfifan, shippingAddress) {

  takhfifan.ShippingAddressView = Backbone.View.extend({

    template: ( $('#tkh-shipping-address-template').length > 0 ) ?
      _.template( $('#tkh-shipping-address-template').html() ) : '',

    events: {
      'click .tkh-edit-shipping-btn': 'triggerEdit',
      'click .tkh-shipping-address-choose': 'submitAddress'
    },

    initialize: function(options) {
      var _this = this;
      this.model.on('change', function() {
        this.render();
        this.setActive();
      }, this);

      takhfifan.eventHub.on('yadisaCO:changeAddress', function(addressId) {
        if(_this.model.get('shipping_address_id') == addressId){
          _this.submitAddress();
        }
      });

      takhfifan.eventHub.on('yadisaCO:editAddress', function(addressId) {
        if(_this.model.get('shipping_address_id') === addressId){
          _this.triggerEdit();
        }
      });

      this.render();
    },

    render: function() {
      this.$el.html( this.template( {data: this.model.toJSON()} ) );
    },

    setActive: function() {
      this.$el.addClass('active');
      takhfifan.eventHub.trigger('shipping:addressesActivated', this.model.get('shipping_address_id'));
    },

    isActive: function() {
      return this.$el.hasClass('active');
    },

    setInactive: function() {
      this.$el.removeClass('active');
    },

    submitAddress: function() {
      if (this.isAddressValid()) {
        takhfifan.eventHub.trigger('shipping:deselectAddresses', this.model);
        this.setActive();
        this.model.save();
      }
    },

    triggerEdit: function() {
      takhfifan.eventHub.trigger('shipping:edit', this.model);
    },

    isAddressValid: function() {
      var addressId = this.model.get('shipping_address_id');

      if (!_.isNull(addressId) && !_.isUndefined(addressId)) {
        Backbone.Validation.bind(this);
        this.model.validate();
        if (this.model.isValid()) {
          Backbone.Validation.unbind(this);
          return true;
        } else {
          Backbone.Validation.unbind(this);
          this.triggerEdit();
          $('.tkh-save-shipping').trigger('click');
        }
      } else {
        this.renderErrors([i18n.t('invalid_shipping_address')]);
      }
      return false;
    }

  });

});

